import styled from 'styled-components';

export const AssetProfileContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const AssetFeatures = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: flex-start;
  align-items: center;
  font-family: Roboto;
  font-size: 10px;
  margin-bottom: 8px;
  margin-top: 8px;
`;

type FeatureCellProps = {
  backgroundcolor: string;
  color: string;
};

export const FeatureCell = styled.div<FeatureCellProps>`
  background-color: ${(props) => props.backgroundcolor};
  padding: 2px 12px 2px 6px;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  column-gap: 5px;
  text-align: center;
  border-radius: 20px;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  height: 30px;

  @media print {
    background-color: ${(props) => props.backgroundcolor} !important;
    color: ${(props) => props.color} !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;

export const AssetProfileInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
  text-align: justify;

  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  font-weight: 700;
`;

export const AssetProfileFeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;
export const AssetProfileLabel = styled.span`
  display: flex;
  align-items: center;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  gap: 4px;
  color: #747d93;
`;
export const AssetProfileValue = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 800;
  color: #363c4b;
`;

export const Separator = styled.span`
  height: 100%;
  width: 1px;
  background-color: #b6bbc6;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;

  @media print {
    background-color: #b6bbc6 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;

export const AddressText = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: clamp(18px, 100vw, 21px);
  font-weight: 500;
  color: #212632;
`;

export const LocationAdmins = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 14px;
  color: #747d93;
`;

export const CadastralRefContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const CadastralRefText = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #1778fb;
`;

export const Description = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 12px;
  padding: 10px 0 0 0;
  color: #747d93;
`;

export const ProfileContainer = styled.div`
  width: 100%;
  height: 336px;
  max-height: 336px;
  border: 1px solid blue;
  padding: 24px 42px 8px 42px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const ProfileTraitsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 4px;
  justify-content: flex-start;
  align-items: center;
  background-color: blue;
  font-family: Roboto;
  font-size: 8px;
  line-height: 12px;
  font-weight: 700;
`;

export const ImagesContainer = styled.div`
  display: grid;
  width: 100%;
  height: 270px; /* or whatever your main image height is */
  grid-template-columns: 440px 1fr; /* main image width, then small images */
  grid-template-rows: 1fr 1fr;
  align-items: stretch;
  justify-items: stretch;
  gap: 10px;
`;

export const MarkerMap = styled.div`
  border-radius: 13px;
  grid-column: 1;
  grid-row: 1/3;
`;
